const tr = {
    num: '編號',
    operator: '操作人',
    oprtTime: '操作時間',
    oprtType: '操作類型',
    orderSource: '訂單來源',
    orderStatus: '訂單狀態',
    orderType: '訂單類型',
    printCount: '列印次數',
    prdctName: '存貨名稱',
    quantity: '數量',
    delTip1: '你確定要刪除這個{{type}}單嗎？',
    delTip2: '刪除後，這個{{type}}單數據不可恢復',
    delSucc: '刪除成功',
    delFail: '刪除失敗,{{content}}',
    orderDetails: '訂單詳情',
    cancel: '取消',
    confirm: '確定',
    confirm2: '確定',
    basicData: '基本數據',
    goods: '商品',
    verificaFailed: '校驗失敗',
    quantityTip1: '商品數量必須大於0',
    quantityTip2: '商品名稱與數量格式必須正確',
    aplicatForm: '申請單',
    prdctList: '商品列表',
    fillQuantity: '請填寫{{type}}數量',
    next: '下一步',
    noGood: '倉庫沒有該商品',
    modificatFailed: '修改失敗',
    tradeName: '商品名稱',
    brand: '型號',
    desc: '描述',
    unit: '組織',
    inboundOprt: '我要入庫',
    outboundOprt: '我要出庫',
    addFailed: '添加失敗',
    prdctSource: '商品來源',
    basicInfo: '基本資訊',
    creator: "製單人",
    createdAt: "製單時間",
    preparedBy: '製單人',
    preparationTime: '製單時間',
    operationSource: '操作來源',
    operationStatus: '操作狀態',
    inTransit: '運輸中',
    inboundCompleted: '已入庫',
    preparing: '備料中',
    outboundCompleted: '已出庫',
    modifyFail: '修改庫存失敗',
    sameCodeTip1: '存在相同條碼，請檢查',
    view: '查看',
    noScanOrder: '掃描單不存在',
    temStorage: '臨時存儲',
    repeatInTip: '條碼{{code}}已存在，不可重複入庫。',
    plFillInData: '刪除apk請填寫數據',
    plFillInDataCompletely: '請將數據填寫完整！',
    tip: '提示',
    cancelTip1: '當前已有數據存在，確認取消嗎？',
    sameCodeSel: '重複條碼選擇',
    sameCode: '重複條碼：',
    plSelSpecifiedProduct: '請選擇指定商品進行操作：',
    productTitle: '產品',
    productCode: '商品編碼',
    barcode: '條碼',
    viewCode: '查看條碼',
    copySuccess: '複製成功！',
    copyFail: '複製失敗！',
    codeListWithCount: '存有條碼清單（共計：{{count}}個）',
    copyAll: '一鍵複製',
    conDelTip1: '倉庫中存在重複條碼，是否刪除以下條碼？',
    conDelTip2: '倉庫中該商品不存在該條碼，是否刪除以下條碼？',
    operationSucc: '操作成功',
    saveSucTip: '臨時存儲成功，可在訂單清單對數據進行操作！',
    saveFailTip: '臨時存儲失敗，{{err}}',
    fetchBarcodesFailt: '條碼査詢失敗，{{err}}',
    searchPl: '請輸入關鍵字進行蒐索',
    searchByOrderNumber: '請輸入單號進行搜索',
    startTime: '開始時間',
    endTime: '結束時間',
    confirmTip: '以下條碼與倉庫中所屬商品不一致',
    serialMumber: '序號',
    barcodesNumber: '條碼數量',
    addDataTip: '請先添加數據',
    selectChangeTypePl: '請選擇操作類型',
    preTime: "送貨時間",
    confirmedTime: "實際出入庫時間",
    editOrder: "編輯訂單",
    quantityConfirm: '數量確認',
    updateOrderSuccess: '更新訂單成功',
    onOrders: '批量下單',
    ordersComfirm: '確定批量下單？',
    optErr: "操作失敗",
    signed: '已簽收',
    noChanges: '沒有變更',
    inOutNo: "出入庫單",
    remark: '備註',
    saleOut: "銷售出庫",
    calcOut: "出庫數據計算",
    saledQty: "已出售數量",
    productionInCount: "生產入庫數量",
    toSaledQty: "待出庫數量",
    curSaledQty: "本次出售數量",
    zeroTip: "至少一個物料的本次出售數量大於0",
    orderSucc: "銷售出庫單已創建成功",
    orderErr: "銷售出庫單創建失敗",
    preOut: "分配庫存",
    needPre: "銷售出庫單請先分配庫存！",
    preOutSucc: "庫存已分配",
    preOutErr: "庫存分配失敗",
    orderContitle: "確定創建銷售預出庫單嗎？",
    outOvernum: "已使用庫存量超出可用庫存量",
    isSwap: "是否轉單單據",
};
export default tr;
